/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Address } from '../models/address';
import { apiStudentByExternalIdExternalIdOnlinePost } from '../fn/student/api-student-by-external-id-external-id-online-post';
import { ApiStudentByExternalIdExternalIdOnlinePost$Params } from '../fn/student/api-student-by-external-id-external-id-online-post';
import { apiStudentByExternalIdExternalIdPatch } from '../fn/student/api-student-by-external-id-external-id-patch';
import { ApiStudentByExternalIdExternalIdPatch$Params } from '../fn/student/api-student-by-external-id-external-id-patch';
import { apiStudentByExternalIdExternalIdTicketsGet } from '../fn/student/api-student-by-external-id-external-id-tickets-get';
import { ApiStudentByExternalIdExternalIdTicketsGet$Params } from '../fn/student/api-student-by-external-id-external-id-tickets-get';
import { apiStudentCounterQuickFiltersGet } from '../fn/student/api-student-counter-quick-filters-get';
import { ApiStudentCounterQuickFiltersGet$Params } from '../fn/student/api-student-counter-quick-filters-get';
import { apiStudentCoursesListPost } from '../fn/student/api-student-courses-list-post';
import { ApiStudentCoursesListPost$Params } from '../fn/student/api-student-courses-list-post';
import { apiStudentItemIdAddressGet } from '../fn/student/api-student-item-id-address-get';
import { ApiStudentItemIdAddressGet$Params } from '../fn/student/api-student-item-id-address-get';
import { apiStudentItemIdCoursesGet } from '../fn/student/api-student-item-id-courses-get';
import { ApiStudentItemIdCoursesGet$Params } from '../fn/student/api-student-item-id-courses-get';
import { apiStudentItemIdGet } from '../fn/student/api-student-item-id-get';
import { ApiStudentItemIdGet$Params } from '../fn/student/api-student-item-id-get';
import { apiStudentOnlineGet } from '../fn/student/api-student-online-get';
import { ApiStudentOnlineGet$Params } from '../fn/student/api-student-online-get';
import { apiStudentOverviewGet } from '../fn/student/api-student-overview-get';
import { ApiStudentOverviewGet$Params } from '../fn/student/api-student-overview-get';
import { apiStudentSyncPost } from '../fn/student/api-student-sync-post';
import { ApiStudentSyncPost$Params } from '../fn/student/api-student-sync-post';
import { CountersCount } from '../models/counters-count';
import { CoursesList } from '../models/courses-list';
import { ImportResult } from '../models/import-result';
import { OnlineStudentsCount } from '../models/online-students-count';
import { Student } from '../models/student';
import { StudentOverviewList } from '../models/student-overview-list';
import { TicketsForStudentList } from '../models/tickets-for-student-list';


/**
 * Student service
 */
@Injectable({ providedIn: 'root' })
export class StudentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiStudentItemIdGet()` */
  static readonly ApiStudentItemIdGetPath = '/api/student/{item_id}';

  /**
   * Get a student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentItemIdGet$Response(params: ApiStudentItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Student>> {
    return apiStudentItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentItemIdGet(params: ApiStudentItemIdGet$Params, context?: HttpContext): Observable<Student> {
    return this.apiStudentItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Student>): Student => r.body)
    );
  }

  /** Path part for operation `apiStudentOverviewGet()` */
  static readonly ApiStudentOverviewGetPath = '/api/student/overview';

  /**
   * Get student overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentOverviewGet$Response(params?: ApiStudentOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentOverviewList>> {
    return apiStudentOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get student overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentOverviewGet(params?: ApiStudentOverviewGet$Params, context?: HttpContext): Observable<StudentOverviewList> {
    return this.apiStudentOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StudentOverviewList>): StudentOverviewList => r.body)
    );
  }

  /** Path part for operation `apiStudentSyncPost()` */
  static readonly ApiStudentSyncPostPath = '/api/student/sync';

  /**
   * Upsert a student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentSyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStudentSyncPost$Response(params: ApiStudentSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
    return apiStudentSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentSyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStudentSyncPost(params: ApiStudentSyncPost$Params, context?: HttpContext): Observable<ImportResult> {
    return this.apiStudentSyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResult>): ImportResult => r.body)
    );
  }

  /** Path part for operation `apiStudentByExternalIdExternalIdTicketsGet()` */
  static readonly ApiStudentByExternalIdExternalIdTicketsGetPath = '/api/student/by-external-id/{external_id}/tickets';

  /**
   * Get tickets for a student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentByExternalIdExternalIdTicketsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentByExternalIdExternalIdTicketsGet$Response(params: ApiStudentByExternalIdExternalIdTicketsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketsForStudentList>> {
    return apiStudentByExternalIdExternalIdTicketsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get tickets for a student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentByExternalIdExternalIdTicketsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentByExternalIdExternalIdTicketsGet(params: ApiStudentByExternalIdExternalIdTicketsGet$Params, context?: HttpContext): Observable<TicketsForStudentList> {
    return this.apiStudentByExternalIdExternalIdTicketsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketsForStudentList>): TicketsForStudentList => r.body)
    );
  }

  /** Path part for operation `apiStudentByExternalIdExternalIdOnlinePost()` */
  static readonly ApiStudentByExternalIdExternalIdOnlinePostPath = '/api/student/by-external-id/{external_id}/online';

  /**
   * Set the last online datetime for a student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentByExternalIdExternalIdOnlinePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentByExternalIdExternalIdOnlinePost$Response(params: ApiStudentByExternalIdExternalIdOnlinePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiStudentByExternalIdExternalIdOnlinePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Set the last online datetime for a student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentByExternalIdExternalIdOnlinePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentByExternalIdExternalIdOnlinePost(params: ApiStudentByExternalIdExternalIdOnlinePost$Params, context?: HttpContext): Observable<void> {
    return this.apiStudentByExternalIdExternalIdOnlinePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStudentOnlineGet()` */
  static readonly ApiStudentOnlineGetPath = '/api/student/online';

  /**
   * Get online students count.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentOnlineGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentOnlineGet$Response(params?: ApiStudentOnlineGet$Params, context?: HttpContext): Observable<StrictHttpResponse<OnlineStudentsCount>> {
    return apiStudentOnlineGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get online students count.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentOnlineGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentOnlineGet(params?: ApiStudentOnlineGet$Params, context?: HttpContext): Observable<OnlineStudentsCount> {
    return this.apiStudentOnlineGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<OnlineStudentsCount>): OnlineStudentsCount => r.body)
    );
  }

  /** Path part for operation `apiStudentCounterQuickFiltersGet()` */
  static readonly ApiStudentCounterQuickFiltersGetPath = '/api/student/counter-quick-filters';

  /**
   * Get quick filtered students count.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentCounterQuickFiltersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentCounterQuickFiltersGet$Response(params?: ApiStudentCounterQuickFiltersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CountersCount>> {
    return apiStudentCounterQuickFiltersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get quick filtered students count.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentCounterQuickFiltersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentCounterQuickFiltersGet(params?: ApiStudentCounterQuickFiltersGet$Params, context?: HttpContext): Observable<CountersCount> {
    return this.apiStudentCounterQuickFiltersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CountersCount>): CountersCount => r.body)
    );
  }

  /** Path part for operation `apiStudentItemIdAddressGet()` */
  static readonly ApiStudentItemIdAddressGetPath = '/api/student/{item_id}/address';

  /**
   * Get the address for a student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentItemIdAddressGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentItemIdAddressGet$Response(params: ApiStudentItemIdAddressGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Address>> {
    return apiStudentItemIdAddressGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the address for a student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentItemIdAddressGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentItemIdAddressGet(params: ApiStudentItemIdAddressGet$Params, context?: HttpContext): Observable<Address> {
    return this.apiStudentItemIdAddressGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Address>): Address => r.body)
    );
  }

  /** Path part for operation `apiStudentItemIdCoursesGet()` */
  static readonly ApiStudentItemIdCoursesGetPath = '/api/student/{item_id}/courses';

  /**
   * Get the list of courses for a student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentItemIdCoursesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentItemIdCoursesGet$Response(params: ApiStudentItemIdCoursesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CoursesList>> {
    return apiStudentItemIdCoursesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the list of courses for a student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentItemIdCoursesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStudentItemIdCoursesGet(params: ApiStudentItemIdCoursesGet$Params, context?: HttpContext): Observable<CoursesList> {
    return this.apiStudentItemIdCoursesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CoursesList>): CoursesList => r.body)
    );
  }

  /** Path part for operation `apiStudentCoursesListPost()` */
  static readonly ApiStudentCoursesListPostPath = '/api/student/courses/list';

  /**
   * Get the list of courses for a students list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentCoursesListPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStudentCoursesListPost$Response(params: ApiStudentCoursesListPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CoursesList>> {
    return apiStudentCoursesListPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the list of courses for a students list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentCoursesListPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStudentCoursesListPost(params: ApiStudentCoursesListPost$Params, context?: HttpContext): Observable<CoursesList> {
    return this.apiStudentCoursesListPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CoursesList>): CoursesList => r.body)
    );
  }

  /** Path part for operation `apiStudentByExternalIdExternalIdPatch()` */
  static readonly ApiStudentByExternalIdExternalIdPatchPath = '/api/student/by-external-id/{external_id}';

  /**
   * Update the external ID of a student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStudentByExternalIdExternalIdPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStudentByExternalIdExternalIdPatch$Response(params: ApiStudentByExternalIdExternalIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiStudentByExternalIdExternalIdPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the external ID of a student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStudentByExternalIdExternalIdPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStudentByExternalIdExternalIdPatch(params: ApiStudentByExternalIdExternalIdPatch$Params, context?: HttpContext): Observable<void> {
    return this.apiStudentByExternalIdExternalIdPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
